import { z } from "zod";

const AppNavigationSchema = z.object({}).strict();

export default AppNavigationSchema;
